export default {"src":"/_next/static/image/public/images/ic_filter_green.8f7b2671bca93a320a1b8532d7ba1615.svg","height":40,"width":40};